import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./TitledBoxedText.module.css";
import ModalColumn from "../ModalColumn/ModalColumn";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { useId } from "react";

type TitledBoxedTextProps = {
  title: string;
  text: string;
};

function TitledBoxedText({ title, text }: TitledBoxedTextProps) {
  const id = useId();

  return (
    <ModalColumn gap="small">
      <FixaText textStyle="Heading.S" tagName="h2">
        {title}
      </FixaText>
      <FixaListView id={id} className={styles["listView"]}>
        <FixaListViewItem title={text} inset emphasised />
      </FixaListView>
    </ModalColumn>
  );
}

export default TitledBoxedText;
